import { jsx } from "react/jsx-runtime";
import { useContext, createContext, useMemo } from "react";
const DefaultBadgePropsContext = createContext({
  bleedY: void 0
});
const DefaultBadgePropsProvider = ({
  bleedY,
  children
}) => {
  const defaultBadgeProps = useMemo(
    () => ({
      bleedY
    }),
    [bleedY]
  );
  return /* @__PURE__ */ jsx(DefaultBadgePropsContext.Provider, { value: defaultBadgeProps, children });
};
const useDefaultBadgeProps = ({
  bleedY: bleedYProp
}) => {
  const { bleedY } = useContext(DefaultBadgePropsContext);
  return {
    bleedY: bleedYProp ?? bleedY ?? false
  };
};
export {
  DefaultBadgePropsProvider,
  useDefaultBadgeProps
};
